/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const SuccessResponse = core.serialization.object({
    success: core.serialization.boolean(),
});
